import React from 'react'

import style from './Style.scss'

type Props = {
  surveyTitle: string | undefined
  surveyDescription: string | undefined
}

export const ReadDescriptionCard = ({
  surveyTitle,
  surveyDescription,
}: Props) => {
  return (
    <div className={style.cardContainer}>
      <div className={style.cardHead}>{surveyTitle}</div>
      <div className={style.cardBody}>{surveyDescription}</div>
    </div>
  )
}
